import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortDashboardComponent } from './port-dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: PortDashboardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortDashboardRoutingModule {}
